import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router';

import { CookiePolicy } from '@ott/cookie-policy';
import Header, { HEADER_THEME_DARK } from '@ott/solar-header';

import { getAuthSelector } from 'src/redux/selectors/commonSelectors';

import SupportChat from 'src/components/blocks/SupportChat';

import { COOKIE_POLICY_LINK } from 'src/constants/common';

import useIsWebview from 'src/hooks/useIsWebview';
import useTypedSelector from 'src/hooks/useTypedSelector';

export const ReportsHeader = () => {
  const [newMessages, setNewMessages] = useState(0);
  const [isSupportChatVisible, setIsSupportChatVisible] = useState(false);
  const [isSupportChatOpen, setIsSupportChatOpen] = useState(false);

  const isWebview = useIsWebview();
  const history = useHistory();

  const auth = useTypedSelector(getAuthSelector);

  const isAuthorized = auth?.data?.auth;

  const handleNewMessages = useCallback((count: number) => {
    setNewMessages(count);
  }, []);

  const handleOpenSupportChat = useCallback((isOpen: boolean) => {
    setIsSupportChatOpen(isOpen);
  }, []);

  const onSupportChatVisible = useCallback((isVisible: boolean) => {
    setIsSupportChatVisible(isVisible);
  }, []);

  return (
    <>
      {!isWebview && (
        <>
          <CookiePolicy cookieLink={COOKIE_POLICY_LINK} isCompact={true} />
          <Header
            theme={HEADER_THEME_DARK}
            history={history}
            showNavigation={true}
            isTransparent={true}
            supportNewMessagesCount={newMessages}
            onOpenSupportChat={handleOpenSupportChat}
            isSupportChatVisible={isSupportChatVisible}
          />
        </>
      )}

      <SupportChat
        isUserAuthorized={isAuthorized}
        isSolar={true}
        isChatButtonHidden={true}
        isOpenFromOutside={isSupportChatOpen}
        onOpenFromOutside={handleOpenSupportChat}
        onReceiveNewMessages={handleNewMessages}
        onCheckAvailability={onSupportChatVisible}
      />
    </>
  );
};
